import { render } from "./PendingExpiredReport.vue?vue&type=template&id=0f851cd4"
import script from "./PendingExpiredReport.vue?vue&type=script&lang=js"
export * from "./PendingExpiredReport.vue?vue&type=script&lang=js"
script.render = render

export default script